import * as React from "react";
const SvgGroup = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.25a4.752 4.752 0 0 0-4.491 3.2.747.747 0 0 0-.509-.2A3.745 3.745 0 0 0 3.25 11c0 .955.357 1.826.944 2.488a5.56 5.56 0 0 0-3.944 5.32c0 .52.422.942.942.942H22.902c.468 0 .848-.38.848-.848a5.654 5.654 0 0 0-3.961-5.395A3.75 3.75 0 0 0 17 7.25a.747.747 0 0 0-.509.2A4.752 4.752 0 0 0 12 4.25Zm4.74 4.454a4.739 4.739 0 0 1-1.6 3.86 6.6 6.6 0 0 1 1.481.686H17a2.25 2.25 0 0 0 0-4.5.749.749 0 0 1-.26-.046ZM7 8.75a.749.749 0 0 0 .26-.046 4.739 4.739 0 0 0 1.6 3.86 6.6 6.6 0 0 0-1.481.686H7a2.25 2.25 0 0 1 0-4.5Zm11.31 6.005a6.6 6.6 0 0 1 1.41 3.495h2.48a4.154 4.154 0 0 0-3.89-3.495Zm-.099 3.495a5.133 5.133 0 0 0-5.093-4.5h-2.236a5.133 5.133 0 0 0-5.093 4.5H18.21Zm-13.931 0a6.6 6.6 0 0 1 1.413-3.498 4.059 4.059 0 0 0-3.905 3.498H4.28Zm7.72-6a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgGroup;
